import Vue from 'vue'

/**
 * 设置基础URL
 */
let base = '/apiv1/dictionary'

/**
 * 查询字典列表(分页)
 */
export const query = (params) => {
  return Vue.fetch.post(`${base}/query`, params).then(data => {
    return data
  })
}
/**
 * 根据类型获取字典列表
 * @param {*} type
 */
export const getByType = (type) => {
  return Vue.fetch.post(`${base}/query/type`, {
    type
  }).then(data => {
    return data.payload
  })
}

/**
 * 新增字典
 * @param {*} params
 */
export const add = (params) => {
  return Vue.fetch.post(`${base}/add`, params)
}

/**
 * 修改字典
 * @param {*} params
 */
export const update = (params) => {
  return Vue.fetch.post(`${base}/update`, params)
}

/**
 * 删除字典
 * @param {*} params
 */
export const remove = (params) => {
  return Vue.fetch.post(`${base}/remove`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/dictionary.js